<template>
  <div>
    <selectTool ref="selectTool"
      ><template slot="btn"
        ><Button @click="getSearchItem" type="error" class="chaxun"
          >查询</Button
        ></template
      ></selectTool
    >

    <Table
      border
      :columns="columns"
      :data="tableData"
      no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(200)"
      @on-row-click="$emit('obj', $event)"
    >
      <template slot-scope="{ row, index }" slot="action">
        <Button size="small" @click="chexiao(row, index)">撤销</Button>
      </template>
    </Table>
    <div id="mypage">
      <div>
        <Page
          :current="1"
          :total="total"
          :page-size="searchItem.pageSize"
          :page-size-opts="[10, 50, 100]"
          show-total
          show-elevator
          show-sizer
          @on-change="changePage"
          @on-page-size-change="pageSizeChange"
        ></Page>
      </div>
    </div>
    <form-model
      title="撤销调度单"
      width="400"
      ref="formModel"
      @tab="now = $event"
    >
      <Button slot="btn" type="primary" @click="addUpdate">提交表单</Button>
    </form-model>
  </div>
</template>
<script>
var ordersGoodsList = [];
export default {
  props: ["scan"],
  data() {
    return {
      isAdd: false,
      openForm: false,
      now: "基本信息",
      columns: [
        {
          type: "index",
          width: 70,
          align: "center",
          sort: 0,
        },
        {
          title: "订单号",
          key: "no",
          width: 150,
          sort: 0,
        },
        {
          title: "订单状态",
          key: "status2",
          sort: 2,
        },
        {
          title: "卡板数",
          key: "pnumber",
          sort: 4,
        },
        {
          title: "业务类型",
          key: "bpMode2",
          sort: 8,
        },
        {
          title: "柜号",
          key: "cabinetNo",
          sort: 9,
        },
        {
          title: "六联单号",
          key: "sixOno",
          sort: 10,
        },
        {
          title: "车辆类型",
          key: "carType",
          sort: 11,
        },
        {
          title: "始发地",
          key: "addressS",
          required: false,
          width: 240,
          type: "selectAddMap",
          sort: 12,
        },
        {
          title: "始发时间",
          key: "timeS2",
          width: 150,
          sort: 13,
        },
        {
          title: "目的地",
          key: "addressD",
          required: false,
          width: 250,
          type: "Selct",
          sort: 14,
        },
        {
          title: "到达时间",
          key: "timeD2",
          required: false,
          width: 150,
          sort: 15,
        },
        {
          title: "收货地址",
          key: "fullAddressD",
          required: false,
          width: 240,
          sort: 16,
        },
        {
          title: "发车地址",
          key: "fullAddressS",
          required: false,
          width: 240,
          sort: 17,
        },
        {
          title: "品名",
          key: "name",
          required: false,
          val: "",
          sort: 18,
        },
        {
          title: "入仓仓库",
          key: "storeName",
          required: false,
          val: "",
          sort: 19,
        },
        {
          title: "条形码",
          key: "barCode",
          required: false,
          val: "",
          sort: 20,
        },
        {
          title: "体积(立方)",
          key: "volume",
          required: false,
          sort: 21,
        },
        {
          title: "型号",
          key: "model",
          required: false,
          val: "",
          sort: 22,
        },
        {
          title: "数量/件",
          key: "amount",
          required: false,
          val: 0,
          sort: 23,
        },
        {
          title: "重量kg",
          key: "weight",
          required: false,
          val: 0,
          sort: 24,
        },
        {
          title: "备注",
          key: "remark",
          required: false,
          val: "",
          sort: 25,
        },
        {
          title: "是否存仓",
          key: "isStore2",
          required: false,
          sort: 26,
        },
        {
          title: "调度员",
          key: "dispatcher",
          required: false,
          sort: 27,
        },
        {
          title: "操作",
          slot: "action",
          sort: 28,
          fixed: "right",
        },
      ],
      tableData: [],
      item: {
        ono: "",
        list: ordersGoodsList,
      },
      transportGoodsListForms: [
        {
          title: "调度单号",
          key: "no",
          type: "Input",
          readonly: true,
          span: 24,
        },
      ],
      transportGoodsListItem: {
        no: "",
      },
      searchItem: {
        pageNumber: 1,
        pageSize: 50,
        startTime: new Date(2023, 4, 1).getTime(),
        endTime: new Date(2023, 6, 1).getTime(),
        no: "",
        carNo: "",
        driver: "",
        sixOno: "",
        carType: "",
        addressD: "",
        addressS: "",
        //status: -1, //0-分单配载, 1-待发车，2-已发车，3 运输中，4 已送达,5 未签收,6 已签收, 7-取消, 8-异常
      },
      total: 0,
      categorys: [],
      forms: [],
      searchForms: [
        {
          title: "六联单号",
          key: "sixOno",
          type: "Input",
        },
        {
          title: "订单号",
          key: "ono",
          type: "Input",
        },
        {
          title: "时间范围",
          key: "startTime",
          key1: "endTime",
          required: true,
          val: 0,
          type: "lyyymmdd",
          times: "4,2,0",
        },
      ],
    };
  },
  methods: {
    getList() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-tms-server-omc/ordersFdpz/listAwait",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        for (let i = 0; i < data.length; i++) {
          data[i].status2 = this.lydic.getVal("orderStatus", data[i].status);
          //data[i].isStore2 = this.$t("bool." + data[i].isStore);
          data[i].bpMode2 = this.lydic.getVal("bpMode", data[i].bpMode);
          data[i].timeS2 = this.utils.time(data[i].timeS, "yymmddhhmm");
          data[i].timeD2 = this.utils.time(data[i].timeD, "yymmddhhmm");
        }
        this.tableData = data;
      });
    },
    addUpdate(name) {
      var a = this.$refs.formModel.getItem();
      if (!a) {
        return;
      }
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-tms-server-omc/orders/cancelFdpz",
        data: this.transportGoodsListItem,
      }).then((res) => {
        if (res) {
          this.$refs.formModel.close();
          this.getList();
        }
      });
    },
    del(row, n) {
      this.$Modal.confirm({
        title: "删除后数据无法恢复，确定要删除？",
        //content: "退出系统后需要重新登录",
        onOk: () => {
          this.axios({
            method: "post",
            url: this.axios.ipPort + "/cloud-tms-server-omc/ordersFdpz/del",
            data: { idList: [row.id] },
          }).then((res) => {
            if (res) {
              this.getList();
            }
          });
        },
      });
    },
    chexiao(row) {
      console.log(row);
      this.transportGoodsListItem.no = row.no;
      //console.log(this.transportGoodsListItem);
      this.$refs.formModel.reach(
        this.transportGoodsListForms,
        this.transportGoodsListItem
      );
    },
    openAdd() {
      this.isAdd = true;
      //this.forms[8].selectItems = this.lydic.getA('addressPrice');
      //this.forms[9].selectItems = this.lydic.getA('addressPrice');
      this.$refs.formModel.reach(this.forms, this.item);
    },
    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    search() {
      this.getList();
    },
    getSearchItem() {
      this.searchItem = this.$refs.selectTool.getItem();
      this.getList();
    },

    reobj(v) {
      this.item.ono = v.no;
      this.openForm = false;
      var obj = {
        pnumber: v.pnumber,
        amount: v.amount,
        weight: v.weight,
        volume: v.volume,
        name: v.name,
        ono: v.no,
        cid: v.cid,
        customer: v.customer,
        sealNo: v.sealNo,
        addressS: v.addressS,
        addressD: v.addressD,
        cabinetNo: v.cabinetNo,
        tradeType: v.tradeType,
        carType: v.carType,
        pickupAddress: v.pickupAddress,
        sendTime: Date.now() + 86400000 * 1.2,
        shipmentTime: Date.now() + 86400000 * 1,
        unloadAddress: v.unloadAddress,

        remark: "",
      };
      ordersGoodsList.push(obj);
    },
  },
  mounted() {
    var config = {
      min: 130,
      max: 300,
    };
    this.columns = this.utils.cols(this.forms, this.columns, config);
    this.$refs.selectTool.reach(this.searchForms, this.searchItem);
    setTimeout(() => {
      this.getSearchItem();
    }, 300);
    //this.dingdanhao();
    //console.log(this.lydic);
    /* setTimeout(() => {
      console.log(this.lydic.getA("addressPrice"));
    }, 2000); */

    // console.log(this.forms[8]);
  },
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/wuliu/fahuo/fendanpeizai2.vue